import axios from "axios";
import { BaseURL } from "../constants/enum/baseURL.emum";

const checkSend = (schedule: number, course: number) => {
  return axios.post("doc3/checkSend", { schedule, course });
};

const checkSendDoc5 = async (doc3id: number) => {
  return axios.get(`doc5/${doc3id}`);
};

const genPdfReportDoc3 = async (schedule: number, curri: number) => {
  return await axios.get(`${BaseURL.BASE_URL}/gendoc3/${schedule}/${curri}`);
};

const ReportService = {
  checkSend,
  checkSendDoc5,
  genPdfReportDoc3,
};
export default ReportService;
